import { useLayoutEffect, useRef } from 'react';
import { gsap } from '../lib/gsap';

const DURATION = 0.6;
const DISTANCE = 28;

function Reveal({ children, delay = 0, className, style, from }) {
  const el = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
        gsap.from(el.current, {
          ...from,
          autoAlpha: 0,
          duration: DURATION,
          delay,
          ease: 'power2.out',
          scrollTrigger: { trigger: el.current, start: 'top 88%', once: true },
        });
      });
    }, el);
    return () => ctx.revert();
  }, [delay]);

  return <div ref={el} className={className} style={style}>{children}</div>;
}

export const FadeUp = (p) => <Reveal {...p} from={{ y: DISTANCE }} />;
export const SlideInLeft = (p) => <Reveal {...p} from={{ x: -DISTANCE }} />;
export const SlideInRight = (p) => <Reveal {...p} from={{ x: DISTANCE }} />;